export default {
    address: 'Address',
    city: 'City',
    email: 'Email',
    phone: 'Phone',
}
